export default "__VITE_ASSET__825310f9__"